
import { mapActions } from 'vuex';

import ImgCtaCard from '@/components/core/img-cta-card/img-cta-card.vue';
import DisclaimerPrivacyTerms from '@/components/static/disclaimer-privacy-terms/disclaimer-privacy-terms.vue';
import PrivacyPolicyModal from '@/components/static/privacy-policy-and-terms-modal/privacy-policy-modal.vue';
import TermsModal from '@/components/static/privacy-policy-and-terms-modal/terms-modal.vue';

export default {
  name: 'ChairYogaV1',
  components: { PrivacyPolicyModal, TermsModal, ImgCtaCard, DisclaimerPrivacyTerms },
  computed: {
    getDisclaimerTextPath() {
      return this.landingContent.secureTextModalDisclaimer;
    },
    landingContent() {
      return this.$t('landingPage.nutritionFasting');
    },
  },
  methods: {
    ...mapActions('quiz', ['pushQuizAnswerToTheStoreAction', 'setDefaultStateValue']),
    handleDefaultState(value) {
      this.pushQuizAnswerToTheStoreAction({ id: 'age', answer: value });
      this.setDefaultStateValue(value);
      this.$router.push('/quiz/start');
    },
    openTermsModal() {
      this.$modal.show('termsModal');
    },
    openPrivacyModal() {
      this.$modal.show('privacyPolicyModal');
    },
  },
};
